import { delay, HttpResponse } from "msw";

export const getConversations = async () => {
  await delay("real");

  return HttpResponse.json({
    conversations: [
      {
        id: "0",
        last_message_timestamp: "2025-03-10T16:29:02.165Z",
        title: "MOCKED 1",
        model: "o3-mini-2025-01-31",
      },
      {
        id: "1",
        last_message_timestamp: "2025-03-11T16:29:02.165Z",
        title: "MOCKED 2",
        model: "gpt-4.1-mini-2025-04-14",
      },
      {
        id: "2",
        last_message_timestamp: "2025-03-12T16:29:02.165Z",
        title: "MOCKED 3",
        model: "o3-mini-2025-01-31",
      },
    ],
  });
};
